import styled from 'styled-components'

import RoundedButton from 'components/RoundedButton'

export const Description = styled.div`
  font-size: 20px;
  margin-top: 15px;
`

export const Button = styled(RoundedButton)`
  width: 100%;
  margin-top: 30px;
`
